import React, { useState, useEffect } from "react";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import ErrorAlert from "../comman/ErrorAlert";
import SuccessAlret from "../comman/SuccessAlert";
import { loginUser, clearErrors } from "../../redux/authSlice";
import { useSelector, useDispatch } from "react-redux";
import Spinner from "../comman/Spinner";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Link } from "react-router-dom";
import Header from "../../CoreFile/Header";
import Footer from "../../CoreFile/Footer";
import {
  sendForgotLink,
  clearMessage,
  clearErrors as clrerr,
} from "../../redux/forgotSlice";
export default function Login() {
  const [showPass, setShowPass] = useState(false);
  const { loading, error, auth } = useSelector((state) => state.auth);
  const {
    loading: load,
    message,
    error: Err,
  } = useSelector((state) => state.forgot);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const initialValues = {
    email: "",
    password: "",
  };

  const validationSchema = Yup.object().shape({
    email: Yup.string().required("Email or username is required"),
    password: Yup.string().required("Password is required"),
  });

  const formik = useFormik({
    initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      dispatch(loginUser(values));
    },
  });

  useEffect(() => {
    if (error) {
      const timer = setTimeout(() => {
        dispatch(clearErrors());
      }, 2000);
      return () => clearTimeout(timer);
    }
    if (Err) {
      const timer = setTimeout(() => {
        dispatch(clrerr());
      }, 2000);
      return () => clearTimeout(timer);
    }
    if (message) {
      const timer = setTimeout(() => {
        dispatch(clearMessage());
      }, 2000);
      return () => clearTimeout(timer);
    }
    if (auth) {
      navigate(`/${auth?.role}/dashboard`);
    }
  }, [error, dispatch, auth, message, Err]);

  const handleForgotPass = () => {
    if (formik.values.email == "") {
      alert("enter email");
    }
    const forgotData = { email: formik.values.email, role: "user" };
    console.log(forgotData);
    dispatch(sendForgotLink(forgotData));
  };
  console.log(Err);
  return (
    <>
      <Header />

     

      

          {/* Left side - red signup section */}
          {/* <div className="relative z-10 w-1/2 p-8 text-white">
            <h2 className="text-2xl font-bold">Welcome!</h2>
            <p className="mt-2">
              Create your account.
              <br />
              For Free!
            </p>
            <div className="mt-6">
              <Link
                  to="/registration" className="rounded-full border-2 border-white px-6 py-2 text-sm font-medium text-white hover:bg-red-600">
                Sign Up
              </Link>
            </div>
          </div> */}

          {/* Right side - White login section */}
          {/* <div className="w-1/2 bg-white p-8">
            <h2 className="mb-6 text-xl font-medium text-gray-700">Login</h2>
            <form onSubmit={formik.handleSubmit}>
              <div className="mb-4">
                <label
                  htmlFor="email"
                  className="mb-1 block text-sm text-gray-600"
                >
                  Email or Username<span className="text-red-500">*</span>
                </label>
                <div className="mt-2">
                  <input
                    id="email"
                    name="email"
                    value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="text"
                    placeholder="Enter email......"
                    required
                     className="w-full rounded border border-gray-300 px-3 py-2 text-sm focus:border-red-500 focus:outline-none"
                  />
                </div>
                {formik.touched.email && formik.errors.email && (
                  <p className="mt-2 text-xs tracking-widest text-left text-red-500">
                    {formik.errors.email}*
                  </p>
                )}
              </div>
              <div className="mb-6">
                <label
                  htmlFor="password"
                  className="mb-1 block text-sm text-gray-600"
                >
                  Password<span className="text-red-500">*</span>
                </label>
                <div className="mt-2 relative">
                  <input
                    id="password"
                    name="password"
                    value={formik.values.password}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type={showPass ? "text" : "password"}
                    placeholder="Password...."
                    required
                    className="w-full  rounded border border-gray-300 px-3 py-2 text-sm focus:border-red-500 focus:outline-none"
                  />
                  <span
                    onClick={() => setShowPass(!showPass)}
                    className="absolute inset-y-0 right-0 top-[18px] transform -translate-y-1/2 pr-3 flex items-center text-white cursor-pointer"
                  >
                    {showPass ? (
                      <FaRegEyeSlash className="text-gray-600" />
                    ) : (
                      <FaRegEye className="text-gray-600" />
                    )}
                  </span>
                </div>
                {formik.touched.password && formik.errors.password && (
                  <p className="mt-2 text-xs tracking-widest text-left text-red-500">
                    {formik.errors.password}*
                  </p>
                )}
              </div>
              {error && <ErrorAlert error={error} />}
              {Err && <ErrorAlert error={Err} />}
              {message && <SuccessAlret message={message} />}
              <div className="flex justify-between mb-3">
              <label className="flex items-center ">
                <input type="checkbox" className="rounded form-checkbox" />
                <span className="ml-2">Remember Me</span>
              </label>
              <span
                  onClick={() => handleForgotPass()}
                  className="text-sm text-red-500 hover:underline"
                >
                  Forgot password?
                </span>
                </div>
              <button
                type="submit"
                className={`w-full uppercase tracking-widest justify-center rounded-full ${
                  loading ? "bg-red-500" : "bg-red-500"
                } px-6 py-2 text-base font-medium leading-6 text-white shadow-sm hover:bg-red-600 focus:outline-none`}
              >
                {loading || load ? <Spinner /> : "Sign In"}
              </button>
              <div className="mt-4 text-gray-600">
              <p className="mt-2 text-center ">Have an account?</p>
              </div>
            </form>
          </div> */}
      <div
  className="h-screen w-full bg-cover bg-center flex items-center justify-center"
  style={{
    backgroundImage:
      "url(https://img.freepik.com/premium-photo/search-bar-icon-search-3d-render-minimal-design-multicolor-background_41204-14142.jpg)",
  }}
>
  <div className="backdrop-blur-md bg-white/10 border border-white/20 rounded-2xl shadow-2xl max-w-md w-full px-8 py-10 text-white">
    <h2 className="text-3xl font-extrabold mb-6 text-center">Welcome Back</h2>

    <form onSubmit={formik.handleSubmit}>
      {/* Email Field */}
      <div className="mb-4">
        <label htmlFor="email" className="block text-sm mb-1">
          Email or Username<span className="text-red-500">*</span>
        </label>
        <input
          id="email"
          name="email"
          value={formik.values.email}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          type="text"
          placeholder="Enter email..."
          required
          className="w-full rounded-md px-4 py-2 bg-white/20 border border-white/30 text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-red-400"
        />
        {formik.touched.email && formik.errors.email && (
          <p className="mt-1 text-xs text-red-400">{formik.errors.email}*</p>
        )}
      </div>

      {/* Password Field */}
      <div className="mb-4">
        <label htmlFor="password" className="block text-sm mb-1">
          Password<span className="text-red-500">*</span>
        </label>
        <div className="relative">
          <input
            id="password"
            name="password"
            value={formik.values.password}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            type={showPass ? "text" : "password"}
            placeholder="Enter password..."
            required
            className="w-full rounded-md px-4 py-2 bg-white/20 border border-white/30 text-white placeholder-white focus:outline-none focus:ring-2 focus:ring-red-400"
          />
          <span
            onClick={() => setShowPass(!showPass)}
            className="absolute top-2 right-3 text-white cursor-pointer"
          >
            {showPass ? <FaRegEyeSlash /> : <FaRegEye />}
          </span>
        </div>
        {formik.touched.password && formik.errors.password && (
          <p className="mt-1 text-xs text-red-400">{formik.errors.password}*</p>
        )}
      </div>

      {/* Alerts */}
      {error && <ErrorAlert error={error} />}
      {Err && <ErrorAlert error={Err} />}
      {message && <SuccessAlret message={message} />}

      {/* Remember Me and Forgot Password */}
      <div className="flex justify-between items-center text-sm mb-6">
        <label className="flex items-center">
          <input type="checkbox" className="form-checkbox text-red-400" />
          <span className="ml-2">Remember me</span>
        </label>
        <span
          onClick={() => handleForgotPass()}
          className="text-red-300 hover:underline cursor-pointer"
        >
          Forgot password?
        </span>
      </div>

      {/* Submit */}
      <button
        type="submit"
        className="w-full bg-gradient-to-r from-[#263283] to-[#ed2924] hover:bg-gradient-to-r hover:from-[#2d3986] hover:to-[#ab3330] transition-all duration-300 text-white text-sm font-semibold py-2 rounded-full"
      >
        {loading || load ? <Spinner /> : "Sign In"}
      </button>
    </form>

    <div className="mt-6 text-center text-sm">
      <span>Don't have an account? </span>
      <Link
        to="/registration"
        className="text-red-300  hover:underline font-semibold"
      >
        Sign up
      </Link>
    </div>
  </div>
</div>

    

      <Footer />
    </>
  );
}
